import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=5a6c51bc&scoped=true&"
import script from "./BaseRadio.vue?vue&type=script&lang=js&"
export * from "./BaseRadio.vue?vue&type=script&lang=js&"
import style0 from "./BaseRadio.vue?vue&type=style&index=0&id=5a6c51bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6c51bc",
  null
  
)

export default component.exports